// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3PrtP","productName":"Table_productName__6CUul"};